type CompanyInfo = {
  name: string;
  sigla: string;
  active: boolean;
};

export enum CompanyId {
  GOIANIA = "667495f531c5299c260f0384",
  CAMPO_GRANDE = "6675839a31c5299c260f03af",
  BRASILIA = "667987c7f9853d0018a5f3ca",
  ANAPOLIS = "66798791f9853d0018a5f3c7",
  CUIABA = "66798815f9853d0018a5f3cd",
  TERESINA = "6679882af9853d0018a5f3ce",
  RIO_VERDE = "6826103383d35312e760cf6e",
  VALPARAISO = "6827a6f2db9f2564a575e920",
  PORTO_SEGURO = "667987eff9853d0018a5f3cb",
  MINEIROS = "667987b0f9853d0018a5f3c9",
  ILHEUS = "667987fdf9853d0018a5f3cc",
  UBERLANDIA = "6679899ff9853d0018a5f3cf",
  SENADOR_CANEDO = "66cf91fd9f2c83765d42836d",
  JATAI = "667987a4f9853d0018a5f3c8",
  RECIFE = "687ba417a5c794a802dbc3f6",
  SAO_LUIS = "687ba437a5c794a802dbc3f7",
  CAMPINAS = "689768ca5e09ebf876c9d51c",
  UNID_MOVEL = "6723fa1e7d6894aeec9cc3a0",
  AGUAS_LINDAS = "68fbb6d674c960298f3cbcfc",
  DOURADOS = "68ae73e02cd64aa107f3583c"
}

export const COMPANIES: Record<CompanyId, CompanyInfo> = {
  [CompanyId.GOIANIA]: { name: "GOIÂNIA", sigla: "GYN", active: true },
  [CompanyId.CAMPO_GRANDE]: { name: "CAMPO GRANDE", sigla: "CGR", active: true },
  [CompanyId.BRASILIA]: { name: "BRASÍLIA", sigla: "BSB", active: true },
  [CompanyId.ANAPOLIS]: { name: "ANÁPOLIS", sigla: "ANP", active: true },
  [CompanyId.CUIABA]: { name: "CUIABÁ", sigla: "CBA", active: true },
  [CompanyId.TERESINA]: { name: "TERESINA", sigla: "TER", active: true },
  [CompanyId.RIO_VERDE]: { name: "RIO VERDE", sigla: "RV", active: true },
  [CompanyId.VALPARAISO]: { name: "VALPARAÍSO", sigla: "VP", active: true },
  [CompanyId.PORTO_SEGURO]: { name: "PORTO SEGURO", sigla: "PS", active: false },
  [CompanyId.MINEIROS]: { name: "Mineiros", sigla: "MNI", active: false },
  [CompanyId.ILHEUS]: { name: "Ilhéus", sigla: "ILH", active: false },
  [CompanyId.UBERLANDIA]: { name: "Uberlândia", sigla: "UBL", active: true },
  [CompanyId.SENADOR_CANEDO]: { name: "Senador Canedo", sigla: "SND", active: false },
  [CompanyId.JATAI]: { name: "JATAI", sigla: "JTI", active: false },
  [CompanyId.RECIFE]: { name: "RECIFE", sigla: "REC", active: true },
  [CompanyId.SAO_LUIS]: { name: "SAO LUIS", sigla: "SLU", active: true },
  [CompanyId.CAMPINAS]: { name: "CAMPINAS", sigla: "CAMP", active: true },
  [CompanyId.UNID_MOVEL]: { name: "UNID. MÓVEL", sigla: "VAN", active: true },
  [CompanyId.AGUAS_LINDAS]: { name: "ÁGUAS LINDAS", sigla: "AGL", active: true },
  [CompanyId.DOURADOS]: { name: "DOURADOS", sigla: "DOU", active: false },
};

export function getCompanySigla(id: string): string {
  return COMPANIES[id as CompanyId]?.sigla || "";
}

export function getCompanyName(id: string): string {
  return COMPANIES[id as CompanyId]?.name || id;
}

export const normalizeCityName = (name: string) => {
  if (!name || typeof name !== 'string')
    return

  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();
}

export function getCompanyIdByName(name: string): CompanyId | undefined {
  const entry = Object.entries(COMPANIES).find(
    ([, info]) => info.name.toUpperCase() === name.toUpperCase()
  );

  return entry ? (entry[0] as CompanyId) : undefined;
}
